import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/DoctorVisual.png";
import React from "react";

export const Contact = () => {
  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="rowcontact align-items-center">
          <Col size={12} md={6}>
            <h2>
              Book a<span style={{ color: "#306AFF" }}> Consultation</span>
            </h2>
            <form className="columncontact">
              <Row>
                <Col
                  style={{ textAlign: "left" }}
                  size={12}
                  sm={6}
                  className="px-1 col-sm-12"
                >
                  <label>Full Name*</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter Full Name"
                    required
                  />
                </Col>
                <Col
                  style={{ textAlign: "left" }}
                  size={12}
                  sm={6}
                  className="px-1"
                >
                  <label>Email*</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter Valid Email"
                    required
                  />
                </Col>
                <Col
                  style={{ textAlign: "left" }}
                  size={12}
                  sm={6}
                  className="px-1"
                >
                  <label>Phone No*</label>
                  <input
                    type="tel"
                    name="phoneno"
                    id="phoneno"
                    placeholder="Enter with Country Code"
                    required
                  />
                </Col>
                {/*<Col size={12} sm={6} className="px-1">
                  <input
                    type="tel"
                    value={formDetails.phone}
                    placeholder="Phone No."
                    onChange={(e) => onFormUpdate("phone", e.target.value)}
                  />
                </Col> */}
                <Col style={{ textAlign: "left" }} size={12} className="px-1">
                  <label>Message*</label>
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Enter Text"
                    required
                  />
                </Col>
              </Row>
              <button className="button-colour1" type="submit">
                Get a Free Consultation
              </button>
            </form>
          </Col>
          <Col size={12} md={6}>
            <img src={contactImg} alt="Contact Us" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
